<template>
    <div v-if="!user.id" class="d-flex justify-center align-center py-10">
        <v-progress-circular indeterminate color="primary" class="my-10"></v-progress-circular>
    </div>
    <v-col v-else cols="12" xl="10" class="px-0">
        <v-form readonly disabled>
            <v-row>
                <v-col cols="12">
                    <h5 class="m-0">{{ t('dms-users::form.title.general_information') }}</h5>
                    <v-divider></v-divider>
                </v-col>
                <v-col cols="12" lg="6" class="py-0">
                    <b-input
                        to-mutate="dms_users::dms_user.username"
                        :label="t('dms-users::form.label.username')"
                    ></b-input>
                </v-col>
                <v-col cols="12" lg="6" class="py-0"> </v-col>
                <v-col cols="12" lg="6" class="pt-0">
                    <b-input
                        to-mutate="dms_users::dms_user.surname"
                        :label="t('dms-users::form.label.surname')"
                    ></b-input>
                </v-col>
                <v-col cols="12" lg="6" class="pt-0">
                    <b-input
                        to-mutate="dms_users::dms_user.forename"
                        :label="t('dms-users::form.label.forename')"
                    ></b-input>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <h5 class="m-0">{{ t('dms-users::form.title.address') }}</h5>
                    <v-divider></v-divider>
                </v-col>
                <v-col cols="12" lg="6" class="py-0">
                    <b-input
                        to-mutate="dms_users::dms_user.address"
                        :label="t('dms-users::form.label.address')"
                    ></b-input>
                </v-col>
                <v-col cols="12" lg="6" class="py-0">
                    <b-input
                        to-mutate="dms_users::dms_user.post_code"
                        :label="t('dms-users::form.label.post_code')"
                    ></b-input>
                </v-col>
                <v-col cols="12" lg="6" class="py-0">
                    <b-input
                        to-mutate="dms_users::dms_user.second_address"
                        :label="t('dms-users::form.label.second_address')"
                    ></b-input>
                </v-col>
                <v-col cols="12" lg="6" class="pt-0">
                    <b-input
                        clearable
                        to-mutate="dms_users::dms_user.country"
                        :label="t('dms-users::form.label.country')"
                    ></b-input>
                </v-col>
                <v-col cols="12" lg="6" class="pt-0">
                    <b-input
                        clearable
                        to-mutate="dms_users::dms_user.region"
                        :label="t('dms-users::form.label.county')"
                    ></b-input>
                </v-col>
                <v-col cols="12" lg="6" class="pt-0">
                    <b-input
                        clearable
                        to-mutate="dms_users::dms_user.town"
                        :label="t('dms-users::form.label.town')"
                        mandatory
                    ></b-input>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <h5 class="m-0">{{ t('dms-users::form.title.contact_details') }}</h5>
                    <v-divider></v-divider>
                </v-col>
                <v-col cols="12" lg="6" class="py-0">
                    <b-input to-mutate="dms_users::dms_user.phone" :label="t('dms-users::form.label.phone')"></b-input>
                </v-col>
                <v-col cols="12" lg="6" class="py-0">
                    <b-input to-mutate="dms_users::dms_user.fax" :label="t('dms-users::form.label.fax')"></b-input>
                </v-col>
                <v-col cols="12" lg="6" class="pt-0">
                    <b-input to-mutate="dms_users::dms_user.email" :label="t('dms-users::form.label.email')"></b-input>
                </v-col>
            </v-row>
        </v-form>
    </v-col>
</template>

<script>
export default {
    computed: {
        user() {
            return this.$store.state.dms_users.dms_user;
        },
        townOptions() {
            return this.$store.state.dms_users.townsOptions.map((x) => ({ value: x.id, text: x.name }));
        },
        countryOptions() {
            return this.$store.state.dms_users.townsOptions.map((x) => ({
                value: x.region.country.id,
                text: x.region.country.name,
            }));
        },
        countyOptions() {
            return this.$store.state.dms_users.townsOptions.map((x) => ({ value: x.region.id, text: x.region.name }));
        },
    },
};
</script>

<style></style>
